import Api from './CollaboratorsModule'


class ApiController {

  async getCollaborators({ params = {} } = {}) {
    const data = await this.#verify(async () => await Api.actions.getCollaborators(null, { params }))
    return data
  }
  async createCollaborator(body) {
    const data = await this.#verify(async () => await Api.actions.createCollaborators(null, body))
    return data
  }
  async editCollaborator(superAdminId, body) {
    const data = await this.#verify(async () => await Api.actions.editCollaborators(null, superAdminId, body))
    return data
  }
  async deleteCollaborator(body) {
    const data = await this.#verify(async () => await Api.actions.deleteCollaborators(null, body))
    return data
  }
  async sendWelcomeEmailToCollaborators(body) {
    const data = await this.#verify(async () => await Api.actions.sendWelcomeEmailToCollaborators(null, body))
    return data
  }

  #verify = async (fn) => {
    try {
      const data = await fn()
      return { data, error: null }
    } catch (error) {
      if (error.response.status === 401) {
        this.$store.dispatch("login/forceLogout");
        this.$router.push("/login");
        return
      }

      return { data: null, error }
    }
  }
}

export const apiController = new ApiController()